import { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import AuthContext from "../context/auth/AuthContext";
import PlatoContext from "../context/platos/PlatoContext";
import FormularioPlato from "../components/FormularioPlato";
import ListadoPlatos from "../components/ListadoPlatos";
import Spinner from "../components/Spinner";

function Platos() {
  const { usuario } = useContext(AuthContext);
  const {
    platos,
    guardando,
    agregarPlato,
    prepararPlato,
    obtenerPlatos,
    eliminarPlato,
  } = useContext(PlatoContext);

  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
    precio: 0,
  });
  const [imagenUrl, setImagenUrl] = useState("");
  const [cargando, setCargando] = useState(false);

  const { nombre, descripcion, precio } = formData;

  useEffect(() => {
    setCargando(true);
    obtenerPlatos();
    setCargando(false);
    return () => {
      setCargando(false);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (guardando) {
      resetForm();
    }

    return () => {
      prepararPlato();
    };
    // eslint-disable-next-line
  }, [guardando]);

  const resetForm = () => {
    setFormData({
      nombre: "",
      descripcion: "",
      precio: 0,
    });
    setImagenUrl("");
    setShow(false);
  };

  const toggler = () => {
    setShow(!show);
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (nombre === "" || descripcion === "" || precio <= 0) {
      toast.error("Por favor provea toda la información");
      return;
    }

    if (imagenUrl === "") {
      toast.error("Debe subir una imagén antes de guardar los datos");
      return;
    }

    const data = {
      nombre: formData.nombre,
      descripcion: formData.descripcion,
      precio: formData.precio,
      imagenUrl: imagenUrl,
      usuarioNombre: usuario.nombre,
      usuarioId: usuario.id,
    };

    agregarPlato(data);
  };

  return cargando ? (
    <Spinner />
  ) : (
    <Container>
      <Titulo>Nuestros Platos</Titulo>
      <BtnShow type="button" onClick={toggler} show={show}>
        {show ? (
          <span>
            <FaMinusCircle /> Cerrar
          </span>
        ) : (
          <span>
            <FaPlusCircle /> Nuevo
          </span>
        )}
      </BtnShow>
      <Division>
        {show ? (
          <FormularioPlato
            formData={formData}
            imagenUrl={imagenUrl}
            setImagenUrl={setImagenUrl}
            onChange={onChange}
            onSubmit={onSubmit}
          />
        ) : (
          <ListadoPlatos platos={platos} eliminarPlato={eliminarPlato} />
        )}
      </Division>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Division = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Titulo = styled.h2`
  font-family: "Caveat", cursive;
  font-size: 2rem;
  margin-top: 0;
  margin-bottom: 20px;
`;

const BtnShow = styled.button`
  width: 8rem;
  height: 2rem;
  padding: 0.5rem;
  margin-bottom: 2rem;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  color: #fff;
  background: ${(props) => (props.show ? "#a61f12" : "#034001")};
  outline: none;
  transition: all 0.5s ease;
  &:hover {
    background: ${(props) => (props.show ? "#d92a1a" : "#055902")};
  }
  span {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
`;

export default Platos;
